export class NumberUtil {

    /**
     * 
     * @param source 
     */
    public static percent(source: number): number {
        const ret = (source ?? 0.0) < 1 ? source : source * .01;
        return ret;
    }
}